module.exports = __webpack_public_path__ + "static/media/Philip.f6754424.jpeg";